<template>
  <div class="center-warp">
    <div class="inner">
      <div class="publish-title">发布通知</div>
      <div class="publish-top">
        <div class="publish-line">
          <div class="creat-title">通知类型<span class="require">*</span></div>
          <el-dropdown trigger="click" @command="noticeTypeChange">
            <div class="box-data d-flex-between">
              <div>{{ showOpt.notice_type ? showOpt.notice_type.name : '通知类型' }}</div>
              <div class="iconfont icon-xialaanniu"></div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{name:'全部',val:3}">全部</el-dropdown-item>
              <el-dropdown-item :command="{name:'指定用户',val:2}">指定用户</el-dropdown-item>
              <el-dropdown-item :command="{name:'指定角色',val:1}">指定角色</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-if="opt.notice_type == 1" class="publish-line">
          <div class="creat-title">通知角色<span class="require">*</span></div>
          <el-dropdown trigger="click" @command="noticeMemberChange">
            <div class="box-data d-flex-between">
              <div>{{ showOpt.notice_member_type ? showOpt.notice_member_type.name : '通知角色' }}</div>
              <div class="iconfont icon-xialaanniu"></div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="item in noticeType" :command="item">{{ item.name }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-if="opt.notice_type == 2" class="publish-line">
          <div class="creat-title">通知对象<span class="require">*</span></div>
          <div class="check-people-line">
            <div class="check-people-line-right">共{{ confirmChooseMemberList.length }}人</div>
            <div class="check-people-line-left">
              <template v-for="(item,index) in confirmChooseMemberList">
                <el-tooltip v-if="index < 5" :content="item.real_name" class="item" effect="dark" placement="top-start">
                  <img :src="item.head_pic" alt="">
                </el-tooltip>
              </template>


              <div class="iconfont icon-xinzeng" @click="openChooseMember"></div>
            </div>
          </div>
        </div>
        <div class="publish-line">
          <div class="creat-title">通知内容<span class="require">*</span></div>
          <el-input
            v-model="opt.content"
            class="publish-textarea"
            maxlength="80"
            placeholder="请输入内容"
            show-word-limit
            type="textarea"
          >
          </el-input>
        </div>
        <div class="publish-line">
          <div class="creat-title">跳转链接</div>
          <input v-model="opt.target_url" class="publish-input" type="text" placeholder="https://">
        </div>
      </div>
      <div class="publish-bottom">
        <div class="add-btn" @click="submit">发布通知</div>
      </div>
      <el-dialog
        :visible.sync="showChooseDialog"
        append-to-body
        custom-class="take-dialog"
        title="选择成员"
        :close-on-click-modal="false"
        width="802px">
        <div class="choose-warp">
          <div v-loading="loading" class="choose-warp-left">
            <div class="choose-warp-left-filter">
              <div class="publish-line">
                <el-dropdown trigger="click" @command="noticeMemberChange2">
                  <div class="box-data d-flex-between">
                    <div>{{ memberOpt.type.name ? memberOpt.type.name : '请选择通知对象分类' }}</div>
                    <div class="iconfont icon-xialaanniu"></div>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="item in noticeType" :command="item">{{ item.name }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="publish-line publish-input">
                <Input v-model="memberOpt.key" :placeholder="'请输入通知对象姓名'" style="padding: 0 15px"
                       @enter="initMember"/>
              </div>
            </div>

<!--            <div class="choose-radio-all">-->
<!--              <div :class="memberList.length ==  chooseMemberList.length? 'icon-yixuan':'icon-weixuan'"-->
<!--                   class="radio iconfont"></div>-->
<!--              <div style="cursor: pointer" @click="chooseMember('add')">全选</div>-->
<!--            </div>-->
            <div class="choose-radio-warp">
              <template v-for="item in memberList">
                <div class="choose-radio-line" @click="chooseMember('self',item)">
                  <div :class="member_ids.indexOf(item.id) !=  -1 ? 'icon-yixuan':'icon-weixuan'"
                       class="radio iconfont"></div>
                  <img :src="item.head_pic" alt="">
                  <div class="choose-radio-name">
                    <div>{{ item.real_name }}</div>
                    <div>{{
                        item.member_type == 0 ? '医生' :
                          item.member_type == 1 ? '导师' :
                            item.member_type == 2 ? '业务员' :
                              item.member_type == 3 ? '客服' :
                                item.member_type == 4 ? '技师' :
                                  item.member_type == 5 ? '供应商' : ''
                      }}
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="choose-warp-right">
            <div class="d-flex-between">
              <div>已选：{{ chooseMemberList.length }}人</div>
              <div @click="chooseMember('del')">全部清除</div>
            </div>
            <div class="choose-head-warp d-flex-warp">
              <div v-for="item in chooseMemberList" class="member-item">
                <img :src="item.head_pic">
                <div class="member-item-name">{{ item.real_name }}</div>
                <div class="member-item-site">{{
                    item.member_type == 0 ? '医生' :
                      item.member_type == 1 ? '导师' :
                        item.member_type == 2 ? '业务员' :
                          item.member_type == 3 ? '客服' :
                            item.member_type == 4 ? '技师' :
                              item.member_type == 5 ? '供应商' : ''
                  }}
                </div>
                <div class="iconfont icon-pizhu-qingkonghuaban member-item-del"
                     @click="chooseMember('self',item)"></div>
              </div>
            </div>
            <div class="take-dialog-bottom">
              <div class="take-dialog-close" @click="showChooseDialog = false">取消</div>
              <div class="take-dialog-open" @click="closeChooseMember">确定</div>
            </div>
          </div>
        </div>

      </el-dialog>
    </div>
  </div>
</template>

<script>
import {CreateNotice, GetMemberList} from "@/http/api";

export default {
  name: "publish",
  data() {
    return {
      showChooseDialog: false,
      noticeType: [
        {
          name: '全部',
          val: undefined
        },
        {
          name: '医生',
          val: 0
        },
        {
          name: '导师',
          val: 1
        },
        {
          name: '业务员',
          val: 2
        },
        {
          name: '客服',
          val: 3
        },
        {
          name: '技师',
          val: 4
        },
        {
          name: '供应商',
          val: 5
        }
      ],
      showOpt: {
        notice_type: {name:'全部',val:3},
        notice_member_type: undefined,
      },
      opt: {
        notice_type: 3,
        notice_member_type: undefined,
        member_ids: [],
        content: '',
        target_url: ''
      },
      memberOpt: {
        key: '',
        type: {
          name: '',
          val: undefined
        }
      },
      memberList: [],
      chooseMemberList: [],
      member_ids: [],
      confirmChooseMemberList: [],
      loading: false
    }
  },
  mounted() {
    this.$store.commit('breadChange', {name: '通知中心', isBack: true})
  },
  methods: {
    initMember() {
      this.loading = true
      GetMemberList({member_type: this.memberOpt.type.val, real_name: this.memberOpt.key, pageSize: 999}).then(res => {
        this.memberList = res.data
        this.loading = false
      })
    },
    noticeTypeChange(val) {
      this.showOpt.notice_type = val
      this.opt.notice_type = val.val
    },
    noticeMemberChange(val) {
      this.showOpt.notice_member_type = val
      this.opt.notice_member_type = val.val
    },
    noticeMemberChange2(val) { //选择对象里面的选择人员弹窗
      this.memberOpt.type = val
      this.initMember()
    },
    openChooseMember() {
      this.showChooseDialog = true
      this.memberOpt = {
        key: '',
        type: {
          name: '',
          val: undefined
        }
      }
      this.chooseMemberList = JSON.parse(JSON.stringify(this.confirmChooseMemberList))
      this.member_ids = []
      this.opt.member_ids.forEach(item => this.member_ids.push(item))
      this.initMember()
    },
    closeChooseMember() {
      this.showChooseDialog = false
      this.confirmChooseMemberList = JSON.parse(JSON.stringify(this.chooseMemberList))
      this.opt.member_ids = []
      this.member_ids.forEach(item => this.opt.member_ids.push(item))
    },
    chooseMember(type, item) {
      let list = this.chooseMemberList
      if (item) {
        let i = list.findIndex(v => v.id == item.id)
        if (i == -1 && type != 'del') {
          this.chooseMemberList.push(item)
          this.member_ids.push(item.id)
        } else if(type != 'add'){
          this.chooseMemberList.splice(i, 1)
          this.member_ids.splice(i, 1)
        }
      } else {
        if (type == 'del') {
          this.chooseMemberList = []
          this.member_ids = []
        } else {
          if (this.memberList.length > this.chooseMemberList.length) {
            //全选 全部选中
            this.memberList.forEach(item => {
              this.member_ids.push(item.id)
              this.chooseMember('add',item)
            })
          } else {
            //全选 全部取消选中
            this.memberList.forEach(item => {
              this.member_ids.push(item.id)
              this.chooseMember('del',item)
            })
          }
        }
      }
    },
    submit() {
      if (!this.opt.notice_type) {
        this.toastSubmit('请选择通知类型')
        return false
      } else if (this.opt.notice_type == 1 && !this.opt.notice_member_type) {
        this.toastSubmit('请选择通知用户角色')
        return false
      } else if (this.opt.notice_type == 2 && !this.opt.member_ids.length) {
        this.toastSubmit('请选择通知用户对象')
        return false
      } else if (this.opt.content.trim() == '') {
        this.toastSubmit('请填写通知内容')
        return false
      }
      CreateNotice(this.opt).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '创建成功'
          })
          this.$router.back()
        } else {
          this.toastSubmit(res.message[0])
        }
      })
    },
    toastSubmit(info) {
      this.$message({
        type: 'error',
        message: info
      })
    }

  }
}
</script>

<style scoped src="../../assets/css/publish_notice.css">
</style>
<style>
.publish-textarea textarea {
  height: 315px;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid #E0E0E0;
  resize: none;
}

.publish-textarea textarea:focus {
  /*border-color: #FED400;*/
  border-color: #E0E0E0;
}
</style>
